export default __webpack_public_path__ + "media/images/logo-symbol-icon-3618410f7adc87419d348e5bd0030050.svg";